import { Header } from "@/components/Header";
import { SearchInput } from "@/components/SearchInput";
import { Clock, ShieldCheck, Info } from "lucide-react";

const FEATURES = [
  {
    title: "Komplette Historie",
    body: "Jeder Schritt mit Datum, Zeit und Status-Code – transparent und nachvollziehbar.",
    icon: Clock,
  },
  {
    title: "Nur mit PLZ",
    body: "Nur wer Sendungsnummer und Empfänger-PLZ kennt, sieht den Status – kein Login nötig.",
    icon: ShieldCheck,
  },
];

export const LandingPage = () => {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="landing-page">
      <Header />

      <main className="mx-auto max-w-3xl px-6 py-16 md:px-10 md:py-24">
        {/* HERO — centered single column */}
        <section className="cb-fade-up flex flex-col items-center text-center">
          <div className="inline-flex w-fit items-center gap-2 rounded-full bg-indigo-100 px-3 py-1.5 text-xs font-semibold uppercase tracking-wider text-indigo-700">
            Sendungsverfolgung
          </div>

          <h1
            className="cb-display mt-6 text-4xl text-slate-900 md:text-5xl lg:text-6xl"
            data-testid="landing-hero-title"
          >
            Verfolgen Sie Ihre<br />Sendung in Echtzeit.
          </h1>

          <p className="mt-5 max-w-xl text-base text-slate-600 md:text-lg">
            Geben Sie einfach die Sendungsnummer und die PLZ des Empfängers
            ein – kein Login erforderlich.
          </p>

          <div className="mt-10 w-full rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200 md:p-8">
            <SearchInput autoFocus />
          </div>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-slate-500">
            <span className="inline-flex items-center gap-1.5">
              <Info size={12} /> 8-stellige Sendungsnummer
            </span>
            <span className="text-slate-300">•</span>
            <span className="inline-flex items-center gap-1.5">
              <Info size={12} /> PLZ inkl. internationaler Formate
            </span>
          </div>
        </section>

        {/* FEATURES */}
        <section className="mt-24" data-testid="landing-features">
          <div className="mb-8 text-center">
            <div className="text-xs font-semibold uppercase tracking-wider text-indigo-600">
              / Wie es funktioniert
            </div>
            <h2 className="cb-display mt-2 text-3xl text-slate-900 md:text-4xl">
              Einfach. Transparent. Zuverlässig.
            </h2>
          </div>

          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
            {FEATURES.map((f, i) => {
              const Icon = f.icon;
              return (
                <div
                  key={f.title}
                  className="rounded-2xl bg-white p-6 ring-1 ring-slate-200 transition-all hover:ring-indigo-300 hover:shadow-sm md:p-7"
                  data-testid={`feature-card-${i}`}
                >
                  <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-indigo-100 text-indigo-600">
                    <Icon size={22} strokeWidth={2} />
                  </div>
                  <div className="mt-5 text-lg font-bold tracking-tight text-slate-900">
                    {f.title}
                  </div>
                  <p className="mt-2 text-sm leading-relaxed text-slate-600">
                    {f.body}
                  </p>
                </div>
              );
            })}
          </div>
        </section>
      </main>

      <footer className="border-t border-slate-200 bg-white">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-3 px-6 py-6 md:flex-row md:items-center md:px-10">
          <div className="text-xs font-medium text-slate-500">
            © {new Date().getFullYear()} ·{" "}
            <a
              href="https://www.kauzwerk.de"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-slate-700 underline-offset-4 hover:underline"
              data-testid="footer-kauzwerk-link"
            >
              KauzWerk
            </a>
          </div>
          <div className="text-xs text-slate-400">Alle Angaben ohne Gewähr</div>
        </div>
      </footer>
    </div>
  );
};
